import Dropdown from "../../Components/Fields/Dropdown";
import {
  baseurl,
  CheckMandatory,
  DeleteRecord,
  ErrorAlert,
  getList,
  GetListDropdown,
  GetRecords,
  saveRecord,
  SuccessAlert,
  UpdateRecord,
  URLPRIFIX,
} from "../../functions/api";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import String from "../../Components/Fields/String";
import { useStore } from "../../Components/StateProvider";
import FormView from "../../Components/Elements/FormView";
import ListView from "../../Components/Elements/ListView";
import { urPK } from "@mui/x-date-pickers/locales";
import { getlocal } from "../../functions/localstorage";
import { URL_Account_Customer_List } from "../../Constancs/apiconst";
import ListViewUp from "../../Components/Elements/ListViewUp";
import BulkActionsBar from "../../Components/Elements/BulkActionsBar";
import ExportOptionsModal from "../../Components/Elements/ExportOptionsModal";

const ContactForm = () => {
  const { option, id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tablename = "contact";
  const setrecord = "/contact/addcontacts";
  const getrecord = `/contact/contacts/${id}`;
  const updaterecord = "/contact/updatecontacts/" + id;
  const props = getlocal("properties");

  const store = useStore();
  const [selectedCategory, setSelectedCategory] = useState("Film");

  const init = {
    client_id: "",
    clientName: "",
    phoneno: "",
    email: "",
    category_ID: "1",
    url: "",
    activeStatus: true,
    film_id: "",
    address: "",
    child: [],
    secondary_emails: [],
  };

  useEffect(() => {
    store.setmodule(tablename, init);

    store.setprops("category_ID", { hidden: true });
    store.setprops("address", { hidden: true });

    if (id != undefined) {
      store.setheader(option.toUpperCase() + " " + tablename);
      LoadInitData();
    } else {
      store.setheader("CREATE NEW " + tablename);
      store.setprops("activeStatus", { hidden: true });
      store.setprops("url", { hidden: true });
      store.setprops("client_id", { mandatory: true });
      store.setprops("email", { mandatory: true });
      store.setprops("film_id", { mandatory: true });
      store.setprops("phoneno", { mandatory: false });
      getContactInformations(store?.state?.records?.contact || {});
    }

    GetListDropdown({
      listUrl: "/clientcategory/getClientCategorylist",
      field: "categoryName",
      sort: "asc",
      count: 100,
      store: store,
    });
    GetListDropdown({
      listUrl: "/api/FilmMaster/getfilms",
      field: "film_name",
      sort: "asc",
      count: 100,
      store: store,
    });
    GetListDropdown({
      listUrl: URL_Account_Customer_List,
      field: "clientname",
      sort: "asc",
      count: 10000,
      store: store,
    });

    if (queryParams.get("client_id") != undefined) {
      store.setprops(
        "client_id",
        queryParams.get("client_id")
          ? {
            mandatory: queryParams.get("client_id").includes("mandatory"),
            readonly: queryParams.get("client_id").includes("readonly"),
            hidden: queryParams.get("client_id").includes("hidden"),
          }
          : { mandatory: true }
      );
    }
    if (queryParams.get("film_id") != undefined) {
      store.setprops(
        "film_id",
        queryParams.get("film_id")
          ? {
            mandatory: queryParams.get("film_id").includes("mandatory"),
            readonly: queryParams.get("film_id").includes("readonly"),
            hidden: queryParams.get("film_id").includes("hidden"),
          }
          : { mandatory: true }
      );
    }
  }, [option, id]);

  useEffect(() => {
    let filmIdProps = {
      mandatory: false,
      hidden: false,
      readonly: option === "view",
    };

    if (selectedCategory === "Film") {
      filmIdProps.mandatory = true;
      // Set the category_ID in the store to the ID corresponding to "Film"
      const filmCategory = store.getprops("categoryName_list")?.find(item => item.label === "Film");
      if (filmCategory) {
        store.setvalue("category_ID", filmCategory.value);
      }
    } else if (selectedCategory === "Rights") {
      filmIdProps.mandatory = true;
      const rightsCategory = store.getprops("categoryName_list")?.find(item => item.label === "Rights");
      if (rightsCategory) {
        store.setvalue("category_ID", rightsCategory.value);
      }
    }

    store.setprops("film_id", filmIdProps);

  }, [selectedCategory, store.getprops("categoryName_list"), option]);
  function LoadInitData() {
    GetRecords(getrecord).then(async (res) => {
      console.log(tablename + " Data - ", res, res.record);
      if (res.success) {
        init.client_id = res.record.parent[0].client_id;
        init.clientName = res.record.parent[0].clientName;
        init.phoneno = res.record.parent[0].phoneno;
        init.email = res.record.parent[0].email;
        init.category_ID = res.record.parent[0].category_ID;
        init.activeStatus = res.record.parent[0].activeStatus;
        init.address = res.record.parent[0].address;
        init.film_id = res.record.parent[0].film_id;
        init.url = res.record.parent[0].url;

        // Set the selectedCategory based on the loaded category_ID
        // const loadedCategory = store.getprops("categoryName_list")?.find(item => item.value === res.record.parent[0].category_ID);
        // if (loadedCategory) {
        //   setSelectedCategory(res.record.parent[0].category_ID === "9" ? "Rights" : "Film");
        // } else {
        //   // Default to "Film" if not found or no category_ID
        //   setSelectedCategory(res.record.parent[0].category_ID === "9" ? "Rights" : "Film");
        // }
        const categoryId = res.record.parent[0].category_ID?.toString();
        setSelectedCategory(categoryId === "9" ? "Rights" : "Film");



        getContactInformations(init);
        if (option === "view") {
          if (res?.record?.projects?.length > 0) {
            var project = res?.record?.projects || [];
            project = project.map((item) => {
              if (item.type == 11) {
                item.type = "Non-Litigation";
              } else if (item.type == 12) {
                item.type = "Litigation";
              } else if (item.type == 13) {
                item.type = "TradeMark";
              }
              return { ...item };
            });
            init.child.Projects = {
              list: project,
              header: [
                ["Project Name", "projectName"],
                ["Type", "type"],
                ["Priority", "priority"],
                ["Status", "status"],
                ["ActiveStatus", "activeStatus"],
                ["Action", "ACTION"],
              ],
            };
          }
          if (res?.record?.formDetails?.length > 0) {
            init.child.formDetails = {
              list: res?.record?.formDetails,
              header: [
                ["Name of Artist", "name_of_Artist"],
                ["Film", "film"],
                ["E-Mail", "email"],
                ["Client Name", "clientName"],
                ["Category Name", "categoryName"],
                ["Status", "status"],
                ["Action", "ACTION"],
              ],
            };
          }
          store.setprops("activeStatus", { hidden: false, readonly: true });
          store.setprops("url", { hidden: false, readonly: true });
          // props for the Mandatory field
          store.setprops("client_id", { mandatory: false, readonly: true });
          store.setprops("email", { mandatory: false, readonly: true });
          // store.setprops("category_ID", { mandatory: false, readonly: true });
          store.setprops("film_id", { mandatory: false, readonly: true }); // Update film_id prop based on category and option
          // store.setprops("address", { mandatory: false, readonly: true });
          store.setprops("phoneno", { mandatory: false, readonly: true });
        } else {
          store.setprops("activeStatus", { hidden: false, readonly: false });
          store.setprops("url", { hidden: false, readonly: true });
          // props for the Mandatory field
          store.setprops("client_id", { mandatory: false, readonly: true });
          store.setprops("email", { mandatory: false, readonly: false });
          // store.setprops("category_ID", {
          //   mandatory: false,
          //   readonly: false,
          // });
          store.setprops("film_id", { mandatory: false, readonly: false }); // Update film_id prop based on category and option
          // store.setprops("address", { mandatory: false, readonly: false });
          store.setprops("phoneno", { mandatory: false, readonly: false });
        }

        store.reset(init);
      } else {
        store.reset({ ...init });
      }
    });
  }

  useEffect(() => {
    console.log("Store", store.state);
  }, [store.state]);

  function getContactInformations(clientname_list = {}) {
    console.log("getContactInformations", clientname_list);

    var secondarycontacts =
      (clientname_list?.secondary_emails &&
        typeof clientname_list?.secondary_emails == "string" &&
        JSON.parse(clientname_list?.secondary_emails)) ||
      [];

    var emailList = [];
    emailList =
      secondarycontacts
        ?.map((contact) =>
          contact.email_Id != "" || contact.email_Id != undefined
            ? { value: contact.email_Id, label: contact.email_Id }
            : undefined
        )
        .filter((item) => item != undefined) || [];
    var phonenoList = [];
    phonenoList =
      secondarycontacts
        ?.map((contact) =>
          contact.phoneno != "" || contact.phoneno != undefined
            ? { value: contact.phoneno, label: contact.phoneno }
            : undefined
        )
        .filter((item) => item != undefined) || [];
    phonenoList.push({
      value: clientname_list?.phoneno,
      label: clientname_list?.phoneno,
    });
    emailList.push({
      value: clientname_list?.email,
      label: clientname_list?.email,
    });
    store.setprops("email_list", emailList);
    store.setprops("phoneno_list", phonenoList);
  }

  function update() {
    store.startLoading();
    let data = store.getrecord();
    data.modifiedBy = store.getuser().id;
    data.id = Number(id);
    data.url = window.location.origin + "/" + URLPRIFIX + "/form";

    if (typeof data.activeStatus === "string") {
      data.activeStatus = data.activeStatus == "true" ? true : false;
    }
    UpdateRecord(updaterecord, data).then((res) => {
      if (res.success) {
        store.stopLoading();
        SuccessAlert("Contact Updated Successfully");

        store.navTo("/" + URLPRIFIX + "/contacts/list");
        store.reset(init);
      } else {
        console.log("errormessage", res);
        store.stopLoading();
        ErrorAlert(
          res?.errormessage?.data || " Error Found Please contact the Admin"
        );
      }
    });
  }
  function Submit() {
    store.startLoading();
    let data = store.getrecord();
    const filteredData = {
      client_id: data.client_id,
      clientName: data.clientName,
      activeStatus: data.activeStatus,
      address: data.address,
      category_ID: selectedCategory == "Film" ? "1" : "9",
      email: data.email,
      film_id: data.film_id,
      phoneno: data.phoneno,
    };
    filteredData.createdBy = store.getuser().id;
    filteredData.url = window.location.origin + "/" + URLPRIFIX + "/forms";
    console.log("Submit", data, filteredData);
    if (typeof filteredData.activeStatus === "string") {
      filteredData.activeStatus =
        filteredData.activeStatus == "true" ? true : false;
    }

    // Custom mandatory check for film_id based on selectedCategory
    let isFilmIdMandatory = false;
    if ((!filteredData.film_id || filteredData.film_id === "")) {
      ErrorAlert("Film Name is mandatory for 'Film' category.");
      store.stopLoading();
      isFilmIdMandatory = true;
    }

    if (!isFilmIdMandatory && CheckMandatory(tablename, store)) {
      saveRecord(setrecord, filteredData).then((res) => {
        console.log("Resonce of saveRecord - ", res);

        if (res.success) {
          res = res?.Id?.list;
          store.stopLoading();
          SuccessAlert("Contact Submitted Successfully");
          if (res != undefined) {
            store.navTo("/" + URLPRIFIX + "/contacts/view/" + res.id, {
              replace: true,
            });
            store.setprops("activeStatus", { hidden: false });
            store.setprops("url", { hidden: false });
            store.setvalue("url", encodeURI(res?.url));
            store.setvalue("activeStatus", res?.activeStatus);
          }
        } else {
          console.log("errormessage", res);
          store.stopLoading();
          ErrorAlert(
            res?.errormessage?.response?.data ||
            " Error Found Please contact the Admin"
          );
        }
      });
    }
  }
  function sentMail() {
    window.open(`mailto:${store.getvalue(
      "email"
    )}?subject=Request for Form Submission to Continue Your Process&body=Hi ${store.getvalue(
      "clientName"
    )}
      %0a
      %0aTo proceed with the next steps, please complete the form at the link provided below:
      %0a
      %0aLink : ${store.getvalue("url")}
      %0a
      %0aPlease Note: This is an automated email. Kindly do not reply to this message. 
      %0a
      %0aRegards
      %0aAbsolute Legal Law Firm`);
  }

  return (
    <FormView
      actions={[
        {
          Name: "Back",
          onclick: () => {
            // store.navTo("/" + URLPRIFIX + "/contacts/list");
            store.navback();
            store.reset(init);
          },
          visible: true,
        },
        {
          Name: "Edit",
          onclick: () => {
            store.navTo(`/${URLPRIFIX}/contacts/edit/${id}`);
          },
          visible: option === "view" && store.getprops("update"),
        },
        {
          Name: "Submit",
          onclick: Submit,
          type: "primary",
          visible: id === undefined,
        },
        {
          Name: "Copy URL",
          onclick: () => {
            navigator.clipboard.writeText(store.getvalue("url"));
            SuccessAlert("Url Copied to clipboard");
          },
          visible: option !== undefined,
        },

        {
          Name: "Send to mail",
          onclick: sentMail,
          visible: option === "edit" && store.getprops("update"),
        },
        {
          Name: "Update",
          onclick: update,
          type: "primary",
          visible: option === "edit" && store.getprops("update"),
        },
        {
          Name: "Re- Send to mail",
          onclick: sentMail,
          visible: option === "view",
        },
        {
          Name: "Create Forms",
          type: "primary",
          onclick: () => {
            let data = store.getrecord();
            // store.navTo(store.getvalue("url"), "_blank");
            window.open(store.getvalue("url"), "_blank");
          },
          visible: option === "view",
        },
        {
          Name: "Create Project",
          type: "primary",
          onclick: () => {
            let data = store.getrecord();
            console.log("On Create Project - ", data);

            // store.setvaluetomodule("project", "projectName", data.film);
            store.setrecord("nonlitigation_project", {
              contact_id: data.client_id,
              film_id: data.film_id,
              projectName: "",
              projectDescription: "",
              startDate: "",
              endDate: "",
              priority: "",
              status: "Draft",
              category_id: data.category_ID,
              activeStatus: true,
              child: [],
              attachmenturl: [],
            });
            store.navTo(
              "/demo/projects/create?contact_id=readonly&film_id=readonly"
            );
          },
          visible:
            getlocal("properties")?.nonlitigation_project?.add &&
            option === "view",
        },
      ]}
    >
      <div className="grid grid-cols-2 gap-6">
        <Dropdown
          name="client_id"
          label="Customer :"
          list={store.getprops("clientname_list") || []}
          onchange={(event) => {
            let clientname_list = store.getprops("clientname_list") || [];
            clientname_list = clientname_list.filter(
              (item) => item.value == event
            )[0];
            getContactInformations(clientname_list);
            store.setvalue("email", clientname_list?.email);
            store.setvalue("phoneno", clientname_list?.phoneno);
            store.setvalue("clientName", clientname_list?.label);
          }}
          onAdd={
            props.customers.add
              ? () => {
                store.navTo("/" + URLPRIFIX + "/customer/create");
              }
              : undefined
          }
          onView={
            props.customers.view
              ? (index) => {
                store.navTo("/" + URLPRIFIX + "/customer/view/" + index);
              }
              : undefined
          }
        />
        <Dropdown
          name="phoneno"
          label="Phone Number :"
          list={store.getprops("phoneno_list") || []}
        />
        <Dropdown
          name="email"
          label="E-mail :"
          list={store.getprops("email_list") || []}
        />
        {/* Category Radio Buttons */}
        <div className="flex items-center"> {/* Change to flex items-center for horizontal alignment */}
          <label className="block text-sm font-medium text-gray-700 mr-2"> {/* Added mr-2 for margin-right */}
            Category :
            <span className="text-[#FF2828]">*</span> {/* Directly adding red asterisk here */}
          </label>
          <div className="flex items-center space-x-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                className="form-radio"
                name="category"
                value="Film"
                checked={selectedCategory === "Film"}
                onChange={() => setSelectedCategory("Film")}
                disabled={option === "view"}
              />
              <span className="ml-2">Film</span>
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                className="form-radio"
                name="category"
                value="Rights"
                checked={selectedCategory === "Rights"}
                onChange={() => setSelectedCategory("Rights")}
                disabled={option === "view"}
              />
              <span className="ml-2">Rights</span>
            </label>
          </div>
        </div>


        <Dropdown
          name="film_id"
          label="Film Name :"
          list={store.getprops("film_name_list") || []}
          onAdd={() => {
            store.setrecord("film", {
              film_name: "",
              activeStatus: true,
            });
            store.navTo("/" + URLPRIFIX + "/filmmaster/create");
          }}
        />

        <String name="address" label="Address :" />
        <Dropdown
          name="activeStatus"
          label="Active Status :"
          list={[
            { value: true, label: "Active" },
            { value: false, label: "InActive" },
          ]}
        />
        <String name="url" label="URL :" />
        {option === "view" && (
          <ChildTabsView
            className="col-span-2 mt-1"
            tabsList={store.getvalue("child") || {}}
            store={store}
            LoadInitData={LoadInitData}
          />
        )}
      </div>
    </FormView>
  );
};

// function ChildTabsView({ tabsList = {}, className = "", store, LoadInitData }) {



//   const defaultTab = tabsList?.formDetails?.list?.length > 0
//     ? "formDetails"
//     : tabsList?.Projects?.list?.length > 0
//       ? "Projects"
//       : ""; 

//   const [tabs, settabs] = useState(defaultTab);
//   const props = getlocal("properties");

//    useEffect(() => {
//   if (tabsList?.formDetails?.list?.length > 0) {
//     settabs("formDetails");
//   } else if (tabsList?.Projects?.list?.length > 0) {
//     settabs("Projects");
//   }
// }, [tabsList]);

//   return (
//     <div className={className}>
//       <ul
//         className={
//           className +
//           " flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400"
//         }
//       >
//         <li className="me-2">
//           {props.forms.view && tabsList?.formDetails?.list?.length > 0 && (
//             <button
//               className={
//                 " p-2 text-primary text-[16px] rounded-t-lg hover:bg-tertiary hover:text-primary " +
//                 ("formDetails" === tabs
//                   ? " bg-Ocean_Blue text-secondary "
//                   : " bg-Alice_Blue ")
//               }
//               onClick={() => {
//                 settabs("formDetails");
//               }}
//             >
//               {"Forms" +
//                 (("formDetails" === tabs &&
//                   " - " + tabsList[tabs]?.list?.length) ||
//                   "")}
//             </button>
//           )}
//           {props.nonlitigation_projects.view &&
//             tabsList?.Projects?.list?.length > 0 && (
//               <button
//                 className={
//                   " p-2 text-primary text-[16px] rounded-t-lg hover:bg-tertiary hover:text-primary " +
//                   ("Projects" === tabs
//                     ? " bg-Ocean_Blue text-secondary "
//                     : " bg-Alice_Blue ")
//                 }
//                 onClick={() => {
//                   settabs("Projects");
//                 }}
//               >
//                 {"Projects" +
//                   (("Projects" === tabs &&
//                     " - " + tabsList[tabs]?.list?.length) ||
//                     "")}
//               </button>
//             )}
//         </li>
//       </ul>

//       <ListView
//         Tablehead={"font-bold text-[18px]"}
//         Tablerecord="pr-[10px] text-[14px] cursor-pointer "
//         onclick={(index) => {
//           if (tabs === "Projects") {
//             if (index.type == "Non-Litigation") {
//               store.navTo("/" + URLPRIFIX + "/projects/view/" + index?.id);
//             } else if (index.type == "Litigation") {
//               store.navTo(
//                 "/" + URLPRIFIX + "/litigation/projects/view/" + index?.id
//               );
//             } else if (index.type == "TradeMark") {
//               store.navTo(
//                 "/" + URLPRIFIX + "/trademark/projects/view/" + index?.id
//               );
//             }
//           }
//           if (tabs === "formDetails") {
//             store.navTo("/" + URLPRIFIX + "/forms/view/" + index?.id);
//           }
//         }}
//         ondelete={
//           tabs == "Projects" && props.nonlitigation_projects.delete
//             ? (item) => {
//               DeleteRecord("/project/deleteproject/" + item.id, {
//                 modifiedBy: store.getuser().id,
//               }).then((res) => {
//                 if (res.success) {
//                   SuccessAlert("Deleted Successfully");
//                   LoadInitData();
//                 } else {
//                   store.stopLoading();
//                   ErrorAlert(
//                     res?.errormessage?.response.data ||
//                     " Unknown Error Found Please contact the Admin"
//                   );
//                 }
//               });
//             }
//             : tabs == "Contacts" && props.contacts.delete
//               ? (item) => {
//                 DeleteRecord("/contact/deletecontacts/" + item.id, {
//                   modifiedBy: store.getuser().id,
//                 }).then((res) => {
//                   if (res.success) {
//                     SuccessAlert("Deleted Successfully");
//                     LoadInitData();
//                   } else {
//                     store.stopLoading();
//                     ErrorAlert(
//                       res?.errormessage?.response.data ||
//                       " Unknown Error Found Please contact the Admin"
//                     );
//                   }
//                 });
//               }
//               : undefined
//         }
//         height={"fit"}
//         header={tabsList[tabs]?.header || []}
//         records={tabsList[tabs]?.list || []}
//       />
//     </div>
//   );
// }

function ChildTabsView({ tabsList = {}, className = "", store, LoadInitData }) {
  const { option, id } = useParams();

  const [tabs, settabs] = useState("formDetails");
  const [showExportOptions, setShowExportOptions] = useState(false);
  const [exportFormat, setExportFormat] = useState("pdf"); // or "excel"

  const props = getlocal("properties");

  const [selectedRecords, setSelectedRecords] = useState([]);
  const [filters, setFilters] = useState({});
  const [sortConfig, setSortConfig] = useState({ field: "", direction: "asc" });

  const handleOnSelect = (item, isChecked) => {
    setSelectedRecords((prev) =>
      isChecked ? [...prev, item] : prev.filter((i) => i.id !== item.id)
    );
  };

  const isSelected = (item) => selectedRecords.some((i) => i.id === item.id);

  const handleSelectAll = () => {
    const all = tabsList[tabs]?.list || [];
    if (selectedRecords.length === all.length) {
      setSelectedRecords([]);
    } else {
      setSelectedRecords(all);
    }
  };

  const handleClickRow = (item) => {
    if (tabs === "Projects") {
      if (item.type === "Non-Litigation") {
        store.navTo(`/${URLPRIFIX}/projects/view/${item.id}`);
      } else if (item.type === "Litigation") {
        store.navTo(`/${URLPRIFIX}/litigation/projects/view/${item.id}`);
      } else if (item.type === "TradeMark") {
        store.navTo(`/${URLPRIFIX}/trademark/projects/view/${item.id}`);
      }
    }
    if (tabs === "formDetails") {
      store.navTo(`/${URLPRIFIX}/forms/view/${item.id}`);
    }
  };

  const handleSort = (label) => {
    setSortConfig((prev) => ({
      field: label,
      direction: prev.field === label && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const onFilterChange = (label, value) => {
    setFilters((prev) => ({ ...prev, [label]: value }));
  };

  const handleBulkDelete = () => {
    const apiPath =
      tabs === "Projects"
        ? "/project/deleteproject/"
        : "/contact/deletecontacts/";
    const deletePermission =
      tabs === "Projects"
        ? props.nonlitigation_projects?.delete
        : props.contacts?.delete;

    if (!deletePermission) return;

    Promise.all(
      selectedRecords.map((item) =>
        DeleteRecord(`${apiPath}${item.id}`, {
          modifiedBy: store.getuser().id,
        })
      )
    ).then(() => {
      SuccessAlert("Selected records deleted");
      LoadInitData();
      setSelectedRecords([]);
    });
  };

  useEffect(() => {
    // Set default tab if formDetails is empty but Projects exist
    if (
      tabs === "formDetails" &&
      (!tabsList?.formDetails?.list?.length || !props.forms.view) &&
      props.nonlitigation_projects.view &&
      tabsList?.Projects?.list?.length
    ) {
      settabs("Projects");
    }
  }, [tabsList]);

  const filteredRecords = (tabsList[tabs]?.list || [])
    .filter((item) =>
      Object.entries(filters).every(([key, value]) =>
        item[key]?.toString()?.toLowerCase().includes(value.toLowerCase())
      )
    )
    .sort((a, b) => {
      if (sortConfig.field) {
        const aValue = a[sortConfig.field];
        const bValue = b[sortConfig.field];
        if (aValue === null || aValue === undefined) return sortConfig.direction === "asc" ? 1 : -1;
        if (bValue === null || bValue === undefined) return sortConfig.direction === "asc" ? -1 : 1;
        if (typeof aValue === 'string' && typeof bValue === 'string') {
          const comparison = aValue.localeCompare(bValue);
          return sortConfig.direction === "asc" ? comparison : -comparison;
        } else {
          if (aValue < bValue) {
            return sortConfig.direction === "asc" ? -1 : 1;
          }
          if (aValue > bValue) {
            return sortConfig.direction === "asc" ? 1 : -1;
          }
          return 0;
        }
      }
      return 0;
    });
  const exportAsPDF = async (selectedRecords) => {
    if (!selectedRecords.length) {
      alert("No records selected");
      return;
    }

    const contactId = selectedRecords[0]?.contactId ?? id;
    if (!contactId) {
      alert("Missing contact ID.");
      return;
    }

    const projectIds = selectedRecords.map((r) => `projectIds=${r.id}`).join("&");

    store.startLoading();

    try {
      const res = await GetRecords(`/contact/contacts/export/${contactId}?format=pdf&${projectIds}`);
      console.log("check the pdf url", res);

      if (res.record?.url) {
        window.open(res.record.url, "_blank");
      } else {
        console.error("No URL in response.");
        alert("Export failed: No URL returned.");
      }
    } catch (error) {
      console.error("PDF export error:", error);
      alert("PDF export failed.");
    } finally {
      store.stopLoading();
    }
  };

  const exportAsExcel = async (selectedRecords) => {
    if (!selectedRecords.length) {
      alert("No records selected");
      return;
    }

    const contactId = selectedRecords[0]?.contactId ?? id;
    if (!contactId) {
      alert("Missing contact ID.");
      return;
    }

    const projectIds = selectedRecords.map((r) => `projectIds=${r.id}`).join("&");

    store.startLoading();

    try {
      const res = await GetRecords(`/contact/contacts/export/${contactId}?format=excel&${projectIds}`);
      console.log("check the excel url", res);

      if (res.record?.url) {
        window.open(res.record.url, "_blank");
      } else {
        console.error("No URL in response.");
        alert("Export failed: No URL returned.");
      }
    } catch (error) {
      console.error("Excel export error:", error);
      alert("Excel export failed.");
    } finally {
      store.stopLoading();
    }
  };

  const handleExport = (format) => {
    const hasProjects = tabsList?.Projects?.list?.length;
    const hasForms = tabsList?.formDetails?.list?.length;

    const selectedProject = selectedRecords.some((r) =>
      (tabsList?.Projects?.list || []).some((p) => p.id === r.id)
    );
    const selectedForm = selectedRecords.some((r) =>
      (tabsList?.formDetails?.list || []).some((f) => f.id === r.id)
    );


    // Show export options only if both are present
    if (selectedProject && selectedForm) {
      setExportFormat(format);

      setShowExportOptions(true);
    } else {
      // Otherwise export immediately with inferred type
      handleConfirmedExport({
        projects: selectedProject,
        forms: selectedForm,
        format
      });
    }
  };


  const handleConfirmedExport = async (options) => {
    const format = options.format || exportFormat;
    setShowExportOptions(false);

    // const contactId = selectedRecords[0]?.contactId ?? id;
    // if (!contactId) {
    //   alert("Missing contact ID.");
    //   return;
    // }

    let recordsToUse = selectedRecords;

    if (options.projects && options.forms) {
      recordsToUse = [...(tabsList?.Projects?.list || []), ...(tabsList?.formDetails?.list || [])];
    } else if (options.projects) {
      recordsToUse = tabsList?.Projects?.list || [];
    } else if (options.forms) {
      recordsToUse = tabsList?.formDetails?.list || [];
    }

    const contactId = recordsToUse[0]?.contactId ?? id;
    if (!contactId) {
      alert("Missing contact ID.");
      return;
    }

    const selectedFormIds = options.forms
      ? recordsToUse
        .filter((r) => (tabsList?.formDetails?.list || []).some((f) => f.id === r.id))
        .map((r) => `formIds=${r.id}`)
      : [];

    const selectedProjectIds = options.projects
      ? recordsToUse
        .filter((r) => (tabsList?.Projects?.list || []).some((p) => p.id === r.id))
        .map((r) => `projectIds=${r.id}`)
      : [];

    if (!selectedFormIds.length && !selectedProjectIds.length) {
      alert("No valid records to export.");
      return;
    }

    let query = `format=${format}`;
    if (selectedProjectIds.length) query += `&${selectedProjectIds.join("&")}`;
    if (selectedFormIds.length) query += `&${selectedFormIds.join("&")}`;

    store.startLoading();

    try {
      const res = await GetRecords(`/contact/contacts/export/${contactId}?${query}`);
      const url = res?.record?.url;
      if (url) {
        window.open(url, "_blank");
      } else {
        alert("No URL returned from export.");
      }
    } catch (err) {
      alert(`${format.toUpperCase()} export failed`);
      console.error(err);
    } finally {
      store.stopLoading();
    }
  };




  return (
    <div className={className}>
      <ul className="flex flex-wrap text-sm font-medium border-b text-gray-500">
        {props.forms.view && tabsList?.formDetails?.list?.length > 0 && (
          <button
            onClick={() => settabs("formDetails")}
            className={`p-2 rounded-t-lg ${tabs === "formDetails"
              ? " bg-Ocean_Blue text-secondary "
              : " bg-Alice_Blue "
              }`}
          >
            Forms - {tabsList?.formDetails?.list?.length}
          </button>
        )}
        {props.nonlitigation_projects.view &&
          tabsList?.Projects?.list?.length > 0 && (
            <button
              onClick={() => settabs("Projects")}
              className={`p-2 rounded-t-lg ${tabs === "Projects"
                ? "bg-Ocean_Blue text-secondary"
                : "bg-Alice_Blue"
                }`}
            >
              Projects - {tabsList?.Projects?.list?.length}
            </button>
          )}
      </ul>

      {selectedRecords.length > 0 && (
        <BulkActionsBar
          selectedRecords={selectedRecords}
          store={store}
          onBulkDelete={handleBulkDelete}
          onExportPDF={() => handleExport("pdf")}
          onExportExcel={() => handleExport("excel")}
        />
      )}
      <ExportOptionsModal
        isOpen={showExportOptions}
        onClose={() => setShowExportOptions(false)}
        onExport={handleConfirmedExport}
      />

      <ListViewUp
        header={tabsList[tabs]?.header || []}
        filteredRecords={filteredRecords}
        Tablehead={"font-bold text-[16px]"}
        Tablerecord="text-[14px] px-2 py-1"
        sortConfig={sortConfig}
        handleSort={handleSort}
        filters={filters}
        onFilterChange={onFilterChange}
        store={store}
        handleOnSelect={handleOnSelect}
        isSelected={isSelected}
        handleClickRow={handleClickRow}
        handleDelete={(item) => {
          const api =
            tabs === "Projects"
              ? "/project/deleteproject/"
              : "/contact/deletecontacts/";

          DeleteRecord(api + item.id, {
            modifiedBy: store.getuser().id,
          }).then((res) => {
            if (res.success) {
              SuccessAlert("Deleted Successfully");
              LoadInitData();
            } else {
              store.stopLoading();
              ErrorAlert(
                res?.errormessage?.response.data ||
                "Unknown Error, please contact Admin"
              );
            }
          });
        }}
        handleSelectAll={handleSelectAll}
        isAllSelected={
          selectedRecords.length === (tabsList[tabs]?.list?.length || 0)
        }
        tablename={tabs === "Projects" ? "projects" : "contacts"}
      />
    </div>
  );
}

export default ContactForm;